var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenprice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47.2982,
    height: 47.2982,
    rx: 14.1895,
    fill: "#468C11",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0145 24.8316C25.0291 24.8316 24.1916 24.4867 23.5018 23.7969C22.812 23.1071 22.4671 22.2696 22.4671 21.2842C22.4671 20.2988 22.812 19.4612 23.5018 18.7715C24.1916 18.0817 25.0291 17.7368 26.0145 17.7368C26.9999 17.7368 27.8375 18.0817 28.5272 18.7715C29.217 19.4612 29.5619 20.2988 29.5619 21.2842C29.5619 22.2696 29.217 23.1071 28.5272 23.7969C27.8375 24.4867 26.9999 24.8316 26.0145 24.8316ZM17.7373 28.3789C17.087 28.3789 16.5304 28.1472 16.0677 27.6836C15.6042 27.2209 15.3724 26.6644 15.3724 26.014V16.5544C15.3724 15.904 15.6042 15.3475 16.0677 14.8847C16.5304 14.4212 17.087 14.1895 17.7373 14.1895H34.2917C34.9421 14.1895 35.499 14.4212 35.9625 14.8847C36.4252 15.3475 36.6566 15.904 36.6566 16.5544V26.014C36.6566 26.6644 36.4252 27.2209 35.9625 27.6836C35.499 28.1472 34.9421 28.3789 34.2917 28.3789H17.7373ZM20.1022 26.014H31.9268C31.9268 25.3637 32.1582 24.8067 32.6209 24.3432C33.0844 23.8805 33.6413 23.6491 34.2917 23.6491V18.9193C33.6413 18.9193 33.0844 18.6875 32.6209 18.224C32.1582 17.7613 31.9268 17.2047 31.9268 16.5544H20.1022C20.1022 17.2047 19.8705 17.7613 19.4069 18.224C18.9442 18.6875 18.3877 18.9193 17.7373 18.9193V23.6491C18.3877 23.6491 18.9442 23.8805 19.4069 24.3432C19.8705 24.8067 20.1022 25.3637 20.1022 26.014ZM33.1092 33.1088H13.0075C12.3571 33.1088 11.8006 32.8774 11.3379 32.4146C10.8743 31.9511 10.6426 31.3942 10.6426 30.7438V17.7368H13.0075V30.7438H33.1092V33.1088ZM17.7373 26.014V16.5544V26.014Z",
    fill: "#468C11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenprice);
export default __webpack_public_path__ + "static/media/greenprice.6ddfec97e71fdd5073d3046381f8ea4c.svg";
export { ForwardRef as ReactComponent };